module.exports = __webpack_public_path__ + "img/dynamic.86e06c4a.png";